/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'

export const loginActionV4NameSchema = z
  .enum([
    'None',
    'MustChangePassword',
    'MustChangeEmail',
    'MustAcceptUserTerms',
    'MustAcceptUserDataPolicy',
  ])
  .describe('Member names of LoginActionV4.')
